import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export async function fetchUserSettings() {
  const res = await fetch(`${API_BASE}/api/user/settings`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الإعدادات'));
  return data;
}

export async function updateUserProfile(payload) {
  const res = await fetch(`${API_BASE}/api/user/settings/profile`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ الملف الشخصي'));
  return data;
}

export async function updateUserPreferences(payload) {
  const res = await fetch(`${API_BASE}/api/user/settings/preferences`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ التفضيلات'));
}

export async function changeUserPassword(payload) {
  const res = await fetch(`${API_BASE}/api/user/settings/password`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تغيير كلمة المرور'));
}
